import React from 'react';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

const PAYMENT_STATUS_META = {
    pending:             { color: 'warning', labelEn: 'Pending',     labelAr: 'قيد الدفع' },
    paid:                { color: 'success', labelEn: 'Paid',        labelAr: 'مدفوع' },
    failed:              { color: 'error',   labelEn: 'Failed',      labelAr: 'فشل الدفع' },
    refunded:            { color: 'success', labelEn: 'Refunded',    labelAr: 'مسترد' },
    partially_refunded:  { color: 'warning', labelEn: 'Partial Refund', labelAr: 'مسترد جزئياً' },
};

const PaymentStatusBadge = ({ status, sx }) => {
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || 'en').startsWith('ar');

    const meta = PAYMENT_STATUS_META[status] || {
        color: 'default',
        labelEn: status || '-',
        labelAr: status || '-',
    };

    return (
        <Chip
            label={isArabic ? meta.labelAr : meta.labelEn}
            size="small"
            color={meta.color}
            variant="tonal"
            sx={{ fontWeight: 'bold', borderRadius: '6px', ...sx }}
        />
    );
};

export default PaymentStatusBadge;
